import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SITE_CONFIG } from "@/config/site";

export const AnnouncementBanner = () => {
  const { announcement } = SITE_CONFIG;
  if (!announcement?.enabled) return null;

  return (
    <div
      className="relative z-[60] w-full bg-gradient-to-r from-violet-600/30 via-indigo-600/30 to-violet-600/30 border-b border-white/10 backdrop-blur-sm"
      data-testid="announcement-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center justify-center gap-3 text-center">
        <p className="text-xs sm:text-sm text-gray-200">
          {announcement.text}
        </p>
        {announcement.ctaLabel && (
          <Link
            to={announcement.ctaHref || "#"}
            className="inline-flex items-center gap-1 text-xs sm:text-sm font-medium text-violet-300 hover:text-white transition-colors duration-200"
            data-testid="announcement-cta"
          >
            {announcement.ctaLabel}
            <ArrowRight className="w-3 h-3" />
          </Link>
        )}
      </div>
    </div>
  );
};

export default AnnouncementBanner;
